(function () {
  var MOBILE_BREAKPOINT = 960;
  var instances = new WeakMap();

  var isMobile = function () {
    return window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px)').matches;
  };

  var updateFraction = function (section, swiper) {
    var fractionEl = section.querySelector('.bob-page__related-fraction');

    if (!fractionEl || !swiper) {
      return;
    }

    var total = swiper.slides ? swiper.slides.length : 0;
    var current = Math.min((swiper.activeIndex || 0) + 1, total);
    fractionEl.textContent = total ? current + '/' + total : '';
  };

  var getEdgeOffset = function (section) {
    var layout = section.closest('.bob-page__layout');

    if (!layout) {
      return 0;
    }

    var edge = parseFloat(window.getComputedStyle(layout).paddingLeft);

    return edge > 0 ? edge : 0;
  };

  var updateEdgeOffset = function (section, swiper) {
    if (!swiper || !swiper.params || !isMobile()) {
      return;
    }

    var offset = getEdgeOffset(section);

    if (swiper.params.slidesOffsetAfter !== offset) {
      swiper.params.slidesOffsetAfter = offset;
      swiper.update();
    }
  };

  var equalizeSlideHeights = function (swiperEl) {
    var slides = swiperEl.querySelectorAll('.bob-page__related-slide');

    if (!slides.length) {
      return;
    }

    slides.forEach(function (slide) {
      slide.style.height = 'auto';
    });

    var maxHeight = 0;

    slides.forEach(function (slide) {
      maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    if (!maxHeight) {
      return;
    }

    slides.forEach(function (slide) {
      slide.style.height = maxHeight + 'px';
    });
  };

  var resetSlideHeights = function (swiperEl) {
    if (!swiperEl) {
      return;
    }

    swiperEl.querySelectorAll('.bob-page__related-slide').forEach(function (slide) {
      slide.style.height = '';
    });
  };

  var initCarousel = function (section) {
    if (!isMobile()) {
      return;
    }

    var swiperEl = section.querySelector('.bob-page__related-swiper');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return;
    }

    var prevEl = section.querySelector('.bob-page__related-nav--prev');
    var nextEl = section.querySelector('.bob-page__related-nav--next');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      speed: 600,
      watchOverflow: true,
      simulateTouch: true,
      grabCursor: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      on: {
        init: function () {
          section.querySelectorAll('.bob-related-card__image').forEach(function (img) {
            img.setAttribute('draggable', 'false');

            if (!img.complete) {
              img.addEventListener(
                'load',
                function () {
                  equalizeSlideHeights(swiperEl);
                },
                { once: true }
              );
            }
          });
          updateEdgeOffset(section, this);
          equalizeSlideHeights(swiperEl);
          updateFraction(section, this);
        },
        slideChange: function () {
          updateFraction(section, this);
        },
        resize: function () {
          updateEdgeOffset(section, this);
          equalizeSlideHeights(swiperEl);
        },
      },
    });

    instances.set(section, { swiper: swiper });
    return swiper;
  };

  var destroyCarousel = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.swiper) {
      resetSlideHeights(section.querySelector('.bob-page__related-swiper'));
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
  };

  var syncCarousel = function (section) {
    if (isMobile()) {
      initCarousel(section);
    } else {
      destroyCarousel(section);
    }
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-bob-related-pages]').forEach(function (section) {
      syncCarousel(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-bob-related-pages]').forEach(function (section) {
      destroyCarousel(section);
    });
  };

  var onResize = function () {
    document.querySelectorAll('[data-bob-related-pages]').forEach(function (section) {
      syncCarousel(section);

      if (isMobile()) {
        var swiperEl = section.querySelector('.bob-page__related-swiper');

        if (swiperEl && swiperEl.swiper) {
          updateEdgeOffset(section, swiperEl.swiper);
          equalizeSlideHeights(swiperEl);
        }
      }
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      window.addEventListener('resize', onResize);
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
        window.addEventListener('resize', onResize);
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
